var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-container", attrs: { id: _vm.id } }, [
    _c("ul", { staticClass: "esArticleMenu no-bullet esCategoryMenu" }, [
      _c(
        "li",
        {
          staticClass: "esArticleMenu__item backgroundColor-hover",
          on: { click: _vm.siteUrlEvent }
        },
        [_vm._v("リンク取得\n    ")]
      ),
      _vm._v(" "),
      _c("li", { staticClass: "esArticleMenu__item backgroundColor-hover" }, [
        _c(
          "a",
          {
            staticClass: "esArticleMenu__item__button",
            attrs: { href: _vm.categoryData.siteItemInfo.settingUrl }
          },
          [_vm._v("\n        編集\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "esArticleMenu__item backgroundColor-hover" }, [
        _c(
          "a",
          {
            staticClass: "esArticleMenu__item__button",
            attrs: {
              href: _vm.categoryData.siteItemInfo.previewUrl,
              target: "_blank"
            }
          },
          [_vm._v("\n        プレビュー\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }